import OrganizationLoginPage from "./organization-login/OrganizationLoginPage";

export default OrganizationLoginPage;



// WEBPACK FOOTER //
// ./src/features/organization/pages/settings/index.js